import React  from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';

const styles = {
    keyboardFocused: {
        color: 'black !important',
        // need linear-gradient here as it will override inline css background, e.g: genres tile
        background: 'linear-gradient(#e0e0e0, #e0e0e0)',
    }
};

function prcButton(props) {
    return  <Button
                disableRipple
                classes={{
                    keyboardFocused: props.classes.keyboardFocused,
                }}
                {...props}>
            {props.children}
            </Button>
}

export default withStyles(styles)(prcButton);
